<template>
  <ai-chat-page />
</template>

<script>
import AiChatPage from "@/pages/tools/ai-chat/index.vue";

export default {
  name: "AiChatMobileRoute",
  layout() {
    return "noheader";
  },
  middleware: ["auth"],
  components: {
    AiChatPage,
  },
};
</script>
<style scoped>
main.child-content-auth {
  padding: 0 !important;
}
</style>